const menuRoutes = [
  {
    name: "Home",
    path: "/",
    outside: false,
    exact: true,
  },
  {
    name: "Dinner & A Show",
    path: "/dinner-and-show",
    outside: false,
    exact: true,
  },
  {
    name: "Shows",
    dropdown: true,
  },
  {
    name: "E Coin",
    path: "/e_coin",
    outside: false,
    exact: true,
  },
  // {
  //   name : 'Gallery',
  //   path : '/galleries',
  //   outside : false,
  //   exact : true,
  // },
  // {
  //   name : 'Events',
  //   path : '/events',
  //   outside : false,
  //   exact : true,
  // },
  {
    name: "Contact",
    path: "/contact",
    outside: false,
    exact: true,
  },
];

export default menuRoutes;
